import './components/newsOrderSelect';
// import "../../../node_modules/fslightbox/index";
import "./components/headerLogoScaleDown";
import "./components/wpml-flags";

import sectionContact from "./components/sectionContact";
import addMaxLength from './components/sectionJoinForm';

sectionContact();
addMaxLength();